module.exports = __webpack_public_path__ + "static/img/tt.c3647d9b.svg";